export function stopPropagation(event) {
  event.stopPropagation();
}

/**
 * This function is used when displaying options in drop-down.
 * Icon for first available options is used in drop-down placeholder.
 */
export const getFirstIcon = config => config[config.options[0]].icon;
